<div class="user-profile--avatar" [ngClass]="{'user-profile--avatar-big': big}" [ngStyle]="{'background-image': 'url(' + user?.photo + ')'}">
</div>
<app-user-online-icon *ngIf="showOnline" [online]="user?.online" size="xs-2" ></app-user-online-icon>
